// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__1VJAz","total":"Cart_total__1mf8T","actions":"Cart_actions__2S_mB","button--alt":"Cart_button--alt__Z4Vg_","button":"Cart_button__jZefr"};